module.exports = __webpack_public_path__ + "img/risklevelR5.4882d929.png";